import { useEffect, useCallback } from 'react';

const TaskListeners = ({ eventEmitter, applyStoreAction, delayedApplyStoreAction }) => {
    const taskAdded = useCallback(task => {
        applyStoreAction({
            type: 'TASK_ADD_SOCKET',
            payload: { task }
        });
    }, [applyStoreAction]);

    const taskRemoved = useCallback(task => {
        applyStoreAction({
            type: 'TASK_REMOVE_SOCKET',
            payload: {
                taskId: task.id,
                parentTaskId: task.task,
                completed: task.completed
            }
        });
    }, [applyStoreAction]);

    const taskArchived = useCallback(task => {
        applyStoreAction({
            type: 'TASK_ARCHIVE_SOCKET',
            payload: { taskId: task.id }
        });
    }, [applyStoreAction]);

    const taskUnarchived = useCallback(task => {
        applyStoreAction({
            type: 'TASK_UNARCHIVE_SOCKET',
            payload: { taskId: task.id }
        });
    }, [applyStoreAction]);

    const taskEdited = useCallback(task => {
        applyStoreAction({
            type: 'TASK_UPDATE_SOCKET',
            payload: {
                taskId: task.id,
                task
            }
        });
    }, [applyStoreAction]);

    const tasksReorder = useCallback(({ tasks }) => {
        applyStoreAction({
            type: 'TASKS_REORDER_SOCKET',
            payload: { tasks }
        });
    }, [applyStoreAction]);

    const subtaskOrdered = useCallback(({ task_id, subtasks, completed }) => {
        applyStoreAction({
            type: 'TASK_ORDER_SUBTASKS_SOCKET',
            payload: {
                taskId: task_id,
                subtaskIds: subtasks.filter(subtaskId => !completed.includes(subtaskId))
            }
        });
    }, [applyStoreAction]);

    const subtasksReorder = useCallback(({ subtasks }) => {
        applyStoreAction({
            type: 'TASKS_REORDER_SOCKET',
            payload: { tasks: subtasks }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('task_added', taskAdded);
        eventEmitter.on('task_removed', taskRemoved);
        eventEmitter.on('task_archived', taskArchived);
        eventEmitter.on('task_unarchived', taskUnarchived);
        eventEmitter.on('task_edited', taskEdited);
        eventEmitter.on('tasks_reorder', tasksReorder);
        eventEmitter.on('subtasks_reorder', subtasksReorder);
        eventEmitter.on('subtask_ordered', subtaskOrdered);

        return () => {
            eventEmitter.off('task_added', taskAdded);
            eventEmitter.off('task_removed', taskRemoved);
            eventEmitter.off('task_archived', taskArchived);
            eventEmitter.off('task_unarchived', taskUnarchived);
            eventEmitter.off('task_edited', taskEdited);
            eventEmitter.off('tasks_reorder', tasksReorder);
            eventEmitter.off('subtasks_reorder', subtasksReorder);
            eventEmitter.off('subtask_ordered', subtaskOrdered);
        };
    };

    useEffect(listen, [eventEmitter, taskAdded, taskRemoved, taskArchived, taskUnarchived, taskEdited, tasksReorder, subtasksReorder, subtaskOrdered]);

    return null;
}

export default TaskListeners;
